<template>
  <div class="os-layout">
    <onboarding-top-bar></onboarding-top-bar>
    <div class="onboarding-content">
      <onboarding-progress-tracker 
        :tabItems="tabItems" ref="progressTracker" v-if="showTracker"
      />
      <router-view 
        :updateStatus="updateStatus" 
        :updateTracker="updateTracker"
        :updateAgreementStatus="updateAgreementStatus"
      ></router-view>
    </div>
    <div v-if="osSection !== '/onboarding/os/finish'" class="buttons">
      <onboarding-button
        @onButtonClick="buttonFunction('prev')"
        type="prev"
        text="Back"
      />
      <div class="right-buttons">
        <a
          v-if="osSection == '/onboarding/os/agreement'"
          class="download-button"
          href="https://arnergy-website.s3.us-west-2.amazonaws.com/Arnergy+-+Outright+Sales+Agreement.pdf "
          target="_blank"
          download
        >
          Download Agreement
        </a>
        <onboarding-button
          @onButtonClick="buttonFunction('next')"
          type="next"
          text="Continue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OnboardingProgressTracker from "../../../OnboardingProgressTracker.vue";
import OnboardingTopBar from "../../../OnboardingTopBar.vue";
import OnboardingButton from "../../../OnboardingButton.vue";
import { mapGetters } from "vuex";

export default {
  name: "OS",
  components: {
    OnboardingTopBar,
    OnboardingButton,
    OnboardingProgressTracker,
  },
  computed: {
    ...mapGetters(["getUserSession"]),
    genRandomNumber() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    },
  },
  data() {
    return {
      packageType: {
        name: '',
        productDescription: '',
        amountOS: 0
      },
      showTracker: false,
      agreementStatus: false,
      osSection: "",
      osRoutes: ["/onboarding/os/agreement", "/onboarding/os/summary", "/onboarding/os/finish"],
      tabItems: [
        {
          title: "Start",
        },
        {
          title: "Agreement",
          percent: "32.5",
          path: "/onboarding/os/agreement",
        },
        {
          title: "Payment Summary",
          percent: "66.2",
          path: "/onboarding/os/summary",
        },
        {
          title: "Finish",
          percent: "100",
          path: "/onboarding/os/finish",
        },
      ],
    };
  },
  methods: {
    buttonFunction(btnType) {
      if (btnType === "prev") return this.handlePrev();
      else if (btnType === "next") {
        switch (this.osSection) {
          case "/onboarding/os/summary":
            this.flutterwavePaygate();
            break;
          case "/onboarding/os/agreement":
            if (this.agreementStatus) this.handleNext() 
            else alert('Please accept the terms and conditions to continue');
            break;
          default:
            this.handleNext();
        }
        // if (this.osSection !== "/onboarding/os/summary") {
        //   if (this.osSection === "/onboarding/os/agreement" && !this.agreementStatus) alert('Please accept the terms and conditions to continue');
        //   else return this.handleNext();
        // }
        // else this.flutterwavePaygate();
      }
    },
    handleNext() {
      let pageRouteIndex = this.osRoutes.indexOf(this.$route.path);
      if (pageRouteIndex < this.osRoutes.length) {
        this.$router.push(this.osRoutes[pageRouteIndex + 1]);
        this.osSection = this.osRoutes[pageRouteIndex + 1];
        this.$refs.progressTracker.setActivePoints();
      }
    },
    handlePrev() {
      let pageRouteIndex = this.osRoutes.indexOf(this.$route.path);
      if (pageRouteIndex > 0) {
        this.$router.push(this.osRoutes[pageRouteIndex - 1]);
        this.osSection = this.osRoutes[pageRouteIndex - 1];
        this.$refs.progressTracker.setActivePoints();
      } else if (pageRouteIndex === 0) this.$router.push("/onboarding");
    },
    flutterwavePaygate() {
      FlutterwaveCheckout({
        public_key: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
        tx_ref: this.genRandomNumber,
        amount: this.packageType.amountOS,
        //amount: "10",
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        redirect_url: "/onboarding/os/finish",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a",
        },
        customer: {
          email: this.getUserSession.email,
          phone_number: this.getUserSession.phoneNumber,
          name:
            this.getUserSession.firstName + " " + this.getUserSession.lastName,
        },
        callback: function (data) {
          console.log(data);
        },
        onclose: function () {
          // close modal
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo: "https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg",
        },
      });
    },
    updateStatus(stateid) {
      const HTTP = this.$httpUtils.instance;
      
      HTTP
        .patch("/onboardingStates", {
          customerid: this.getUserSession.id,
          stateid: stateid,
          packageType: 'OS',
          id: this.$store.state.onboardingCustomerState.id
        })
        .then(res => this.$store.commit("saveOnboardingCustomerState", res.data))
        .catch(error => console.log({ error }));
    },
    getOnboardingState(id) {
      const HTTP = this.$httpUtils.instance;
      HTTP
        .get(`/onboardingStates/findOne?filter={"where":{"customerid":${id}}}`)
        .then(response => {
          if (this.$route.path !== this.osRoutes[response.data.stateid - 1]) {
            this.$router.push(this.osRoutes[response.data.stateid - 1])
          }
        })
        .catch(error => console.log({ error }));
    },
    updateTracker(bool) { this.showTracker = bool; },
    updateAgreementStatus(bool) { this.agreementStatus = bool },
  },
  mounted() {
    this.getOnboardingState(this.getUserSession.id);
    this.osSection = this.$route.path;
    this.packageType = this.$store.state.onboardingPackageType;
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

.os-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
}

.onboarding-content {
  padding: 0px 127px;
  flex: 1;
  overflow-y: scroll;
}

.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 127px;
  height: 70px;
}

.buttons,
.right-buttons {
  display: flex;
  align-items: center;
}

.download-button {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-right: 35px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/outrightSale/index.vue